import {
  Contents,
  EpubCFI,
  Rendition,
  RenditionLocation,
  Section,
  View,
} from '../types/epubs';

export const onRelocated = (
  rendition: Rendition,
  handler: (data: {
    atStart: boolean;
    start: RenditionLocation;
    end: RenditionLocation;
  }) => void
) => rendition.on('relocated', handler);

export const onDisplayed = (
  rendition: Rendition,
  handler: (data: Section) => void
) => rendition.on('displayed', handler);

export const onSelected = (
  rendition: Rendition,
  handler: (cfirange: string, contents: Contents) => void
) => rendition.on('selected', handler);

export const onRendered = (
  rendition: Rendition,
  handler: (contents: Section, view: View & { contents: Contents }) => void
) => rendition.on('rendered', handler);
export const onMarkClicked = (
  rendition: Rendition,
  handler: (cfirange: EpubCFI, data: {}, contents: Contents) => void
) => rendition.on('markClicked', handler);
export const onClick = (
  rendition: Rendition,
  handler: (e: MouseEvent) => void
) => rendition.on('click', handler);
